import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useMediaStore } from '../../../store/media.store';
import { usePlayerStore } from '../../../store/player.store';
// Importing 3rd party dependencies
import { useMemo, useRef } from 'react';
import { useWavesurfer } from '@wavesurfer/react';
// ----------------------------------------------------------------------
export const Waveform = () => {
    // Adding player store
    const { duration, played } = usePlayerStore(useShallow((state) => ({
        duration: state.duration,
        played: state.played,
    })));
    // Adding media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Creating ref for waveform container
    const containerRef = useRef(null);
    // Memoizing peaks & bar width
    // We do this to prevent re-rendering
    const peaks = useMemo(() => media === null || media === void 0 ? void 0 : media.peaks, [media]);
    const barWidth = useMemo(() => {
        if (Math.round((8 / peaks.length) * 1000) < 1) {
            return 1;
        }
        else if (Math.round((8 / peaks.length) * 1000) > 4) {
            return 4;
        }
        else {
            return Math.round((8 / peaks.length) * 1000);
        }
    }, [peaks]);
    // Creating wavesurfer instance
    const { wavesurfer } = useWavesurfer({
        autoCenter: true,
        autoScroll: true,
        backend: 'MediaElement',
        barGap: 2,
        barRadius: 8,
        barWidth,
        container: containerRef,
        cursorWidth: 0,
        duration: duration,
        interact: false,
        normalize: true,
        mediaControls: false,
        peaks: peaks,
        progressColor: 'rgba(43, 50, 135, 0.95)',
        waveColor: 'rgba(255, 255, 255, 0.75)',
    });
    // Updating wavesurfer played time based on player played time
    useMemo(() => {
        wavesurfer === null || wavesurfer === void 0 ? void 0 : wavesurfer.setTime(Math.round(played * duration));
    }, [wavesurfer, played, duration]);
    // Rendering waveform
    return _jsx("div", { ref: containerRef });
};
